import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormValidationService } from './form-validation-service'
import { Validatable } from './validatable'
import { RequestCheck } from './request-validator'

@Component({
    selector: 'ValidatedRequestTextField',
    templateUrl: './html-templates/validated-text-field.component.html'
})
export class ValidatedRequestTextField extends Validatable<RequestCheck> {
    @Input() text = ''
    @Input() label = ''
    @Input() id = ''
    @Input() for = ''
    @Input() maxlength = ''
    @Input() minlength = ''
    @Input() helperText = ''
    @Input() type = 'text'
    @Input() originalValue: string
    @Input() requiredField: boolean = false
    @Output() onValueChange: EventEmitter<string> = new EventEmitter<string>()

    constructor(formValidationService: FormValidationService) {
        super(formValidationService)
    }

    getDescribedBy(): string {
        const baseId = this.id || this.for;
        const parts: string[] = [];
        if (this.requiredField) {
            parts.push(`${baseId}-required`);
        }
        if (this.errorMessages.length) {
            parts.push(`${baseId} - error`);
        }
        return parts.join('');
    }

    onBlur() {
        this.validate()
    }

    getLabel() {
        return this.label
    }

    getId() {
        return this.id
    }

    getValue() {
        return {
            originalValue: this.originalValue,
            currentValue: this.text
        }
    }
}
